var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.019,
    height: 15,
    viewBox: "0 0 18.019 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M.171,8.353,6.553,2.159a.563.563,0,0,1,.955.4V5.755a10.711,10.711,0,0,1,10.511,10.7.554.554,0,0,1-.429.532.537.537,0,0,1-.133.017.592.592,0,0,1-.509-.3A9.575,9.575,0,0,0,8.572,11.76H7.508v3.191a.563.563,0,0,1-.955.4L.171,9.161a.562.562,0,0,1,0-.808Z",
    transform: "translate(0 -2)",
    fill: "#3b56a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e6f0da7dc78dd348cde95b510ab67345.svg";
export { ForwardRef as ReactComponent };